// extracted by mini-css-extract-plugin
module.exports = {"stroke":"page_stroke__FomIL"};